<template>
  <div class="tax-result-container">
    <van-nav-bar
      title="代缴个税查询"
      left-arrow
      @click-left="onClickLeft"
    />
    
    <div class="filter-section">
      <div class="filter-item">
        <span>年度</span>
        <van-dropdown-menu>
          <van-dropdown-item v-model="filter.year" :options="yearOptions" />
        </van-dropdown-menu>
      </div>
      <div class="filter-item">
        <span>姓名</span>
        <van-dropdown-menu>
          <van-dropdown-item v-model="filter.name" :options="nameOptions" />
        </van-dropdown-menu>
      </div>
    </div>

    <div class="summary-section">
      <div class="summary-item">
        <div class="amount">¥ {{ yearlyIncome }}</div>
        <div class="label">年度已申报收入</div>
      </div>
      <div class="summary-item">
        <div class="amount">¥ {{ yearlyTax }}</div>
        <div class="label">年度代缴个税</div>
      </div>
    </div>

    <div v-for="(month, index) in monthlyData" :key="index" class="month-section">
      <div class="month-title">{{ filter.year }}年{{ month.month }}月</div>
      
      <div class="month-summary">
        <div class="summary-item">
          <div class="amount">¥ {{ month.income }}</div>
          <div class="label">已申报收入</div>
        </div>
        <div class="summary-item">
          <div class="amount">¥ {{ month.tax }}</div>
          <div class="label">代缴个税</div>
        </div>
      </div>

      <div v-if="month.withdrawals && month.withdrawals.length > 0">
        <div class="section-title">余额提现</div>
        <div v-for="(withdrawal, wIndex) in month.withdrawals" :key="wIndex" class="withdrawal-item">
          <div class="withdrawal-info">
            <div>提现手续费：{{ withdrawal.fee }}</div>
            <div>代扣税：{{ withdrawal.tax }}</div>
            <div>实际到账：{{ withdrawal.actualAmount }}</div>
            <div>{{ withdrawal.time }}</div>
          </div>
          <div class="withdrawal-amount">-{{ withdrawal.amount }} ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TaxQueryResult',
  data() {
    return {
      filter: {
        year: '2025年',
        name: '张三'
      },
      yearOptions: [
        { text: '2025年', value: '2025年' },
        { text: '2024年', value: '2024年' },
        { text: '2023年', value: '2023年' }
      ],
      nameOptions: [
        { text: '张三', value: '张三' },
        { text: '李四', value: '李四' }
      ],
      // 模拟数据
      yearlyIncome: '13000',
      yearlyTax: '13000',
      monthlyData: [
        {
          month: '11',
          income: '13000',
          tax: '1000',
          withdrawals: [
            {
              fee: '0.99',
              tax: '100',
              actualAmount: '99.01',
              amount: '200',
              time: '2025-11-30 16:55:53'
            },
            {
              fee: '0.99',
              tax: '100',
              actualAmount: '99.01',
              amount: '200',
              time: '2025-11-3 16:55:53'
            }
          ]
        },
        {
          month: '10',
          income: '13000',
          tax: '1300',
          withdrawals: [
            {
              fee: '0.99',
              tax: '100',
              actualAmount: '99.01',
              amount: '200',
              time: '2025-10-23 16:55:53'
            }
          ]
        }
      ]
    }
  },
  created() {
    // 从路由参数获取查询信息
    const { name, idCard, year } = this.$route.query
    if (name && year) {
      this.filter.name = name
      this.filter.year = year
      // 这里应该调用API获取实际数据
      this.fetchTaxData(name, idCard, year)
    }
  },
  methods: {
    onClickLeft() {
      this.$router.back()
    },
    fetchTaxData(name, idCard, year) {
      // 实际项目中，这里应该调用API获取数据
      // 这里使用模拟数据
      console.log(`查询${name}(${idCard})在${year}的个税数据`)
      // 实际项目中应该替换为API调用
      // this.axios.get('/api/tax/query', { params: { name, idCard, year } })
      //   .then(response => {
      //     const data = response.data
      //     this.yearlyIncome = data.yearlyIncome
      //     this.yearlyTax = data.yearlyTax
      //     this.monthlyData = data.monthlyData
      //   })
    }
  }
}
</script>

<style scoped>
.tax-result-container {
  min-height: 100vh;
  background-color: #f7f8fa;
  padding-bottom: 20px;
}

.filter-section {
  display: flex;
  background-color: #fff;
  padding: 10px 15px;
  margin-bottom: 10px;
}

.filter-item {
  display: flex;
  align-items: center;
  margin-right: 15px;
}

.filter-item span {
  margin-right: 5px;
}

.summary-section {
  display: flex;
  background-color: #fff;
  padding: 15px;
  margin-bottom: 10px;
}

.summary-item {
  flex: 1;
  text-align: center;
}

.amount {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 5px;
}

.label {
  font-size: 14px;
  color: #666;
}

.month-section {
  background-color: #fff;
  margin-bottom: 10px;
  padding: 15px;
}

.month-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

.month-summary {
  display: flex;
  margin-bottom: 15px;
}

.section-title {
  font-size: 14px;
  color: #666;
  margin: 10px 0;
}

.withdrawal-item {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.withdrawal-info {
  font-size: 12px;
  color: #666;
}

.withdrawal-amount {
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
}
</style>